import {AxiosInstance} from "axios";
import {Sharing, SharingStatus} from "@/core/interfaces/Sharing";

interface SharingRequest {
    consumer_key?: string;
    status?: SharingStatus;
}

const SharingResource = (client: AxiosInstance) => {

    /**
     * List all sharings where the user organization is the owner.
     */
    const indexAsOwner = async (params: SharingRequest = {}): Promise<Sharing[]> => {
        return client.get('sharings/ownerships', {params})
            .then((response) => response.data.data);
    };

    /**
     * Accept a sharing request.
     *
     * @param id
     * @param comment
     */
    const accept = async (id: number, comment = "") => {
        return client.patch(`/sharings/${id}/authorize`, {comment})
            .then((response) => response.data.data);
    };

    /**
     * Decline a sharing request.
     *
     * @param id
     * @param comment
     */
    const decline = async (id: number, comment = "") => {
        return client.patch(`/sharings/${id}/decline`, {comment})
            .then((response) => response.data.data);
    };

    /**
     * Get the list of sharing where the current organization is the owner.
     *
     * @param params
     */
    const ownerships = async (params: SharingRequest = {}): Promise<Sharing[]> => {
        return client.get('/sharings/ownerships', {params})
            .then((response) => response.data.data);
    };

    return {
        indexAsOwner,
        accept,
        decline,
        ownerships
    };
};

export default SharingResource;
